import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';


@Injectable()
export class NotificationService {
    constructor(private http: HttpClient) { }

    getNotificationList(obj) {

        const temp = { user_id: obj.user_id, role: obj.role };
        let selectedApi;
        if (obj.role === 'schoolAdmin'){
            selectedApi = 'fetchNotifications';
        }
        if (obj.role === 'teacher'){
            selectedApi = 'fetchNotificationForTeacher';
        }
        return this.http.post(environment.restAPI + selectedApi,
            temp, {
            }).pipe(map((res: any) => res));

    }

    getNotificationDetails(reqID) {

        const temp = { requestId: reqID };
        return this.http.post(environment.restAPI + 'fetchParticularRequestDetails',
            temp, {
            }).pipe(map((res: any) => res));

    }

    getNotificationResolution(obj, status, currentObj) {

        const temp = {
            request: obj.request,
            details: obj.details,
            status: status,
            currentObj: currentObj
        };
        if (status === 'forwarded'){
            return this.http.post(environment.restAPI + 'forwardTheRequest', temp, {}).pipe(map((res: any) => res));
        } else {
            return this.http.post(environment.restAPI + 'requestApproveOrDeny', temp, {}).pipe(map((res: any) => res));
        }
    }
	 renewToken() {
        let refresh_token = window.localStorage.getItem("refresh_token");
        return this.http.get(environment.restAPI + 'access/renew/' + refresh_token,
        {
        }).pipe(map((res: any) => res))
    }
}
